import { c as _c } from "react/compiler-runtime";
import { useTranslation } from 'react-i18next';
import Section from '../section';
const InvestorProfileSection = () => {
  const $ = _c(42);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      keyPrefix: "collectData.person.investor"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useTranslation("playbook-builder", t0);
  let t1;
  if ($[1] !== t) {
    t1 = t(_temp);
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t) {
    t2 = t(_temp2);
    $[3] = t;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t2) {
    t3 = <li>{t2}</li>;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t) {
    t4 = t(_temp3);
    $[7] = t;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t4) {
    t5 = <li>{t4}</li>;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t) {
    t6 = t(_temp4);
    $[11] = t;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t6) {
    t7 = <li>{t6}</li>;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t) {
    t8 = t(_temp5);
    $[15] = t;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== t8) {
    t9 = <li>{t8}</li>;
    $[17] = t8;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== t) {
    t10 = t(_temp6);
    $[19] = t;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== t10) {
    t11 = <li>{t10}</li>;
    $[21] = t10;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] !== t) {
    t12 = t(_temp7);
    $[23] = t;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  let t13;
  if ($[25] !== t12) {
    t13 = <li>{t12}</li>;
    $[25] = t12;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  let t14;
  if ($[27] !== t) {
    t14 = t(_temp8);
    $[27] = t;
    $[28] = t14;
  } else {
    t14 = $[28];
  }
  let t15;
  if ($[29] !== t14) {
    t15 = <li>{t14}</li>;
    $[29] = t14;
    $[30] = t15;
  } else {
    t15 = $[30];
  }
  let t16;
  if ($[31] !== t11 || $[32] !== t13 || $[33] !== t15 || $[34] !== t3 || $[35] !== t5 || $[36] !== t7 || $[37] !== t9) {
    t16 = <ul className="flex flex-col gap-2 ml-4 list-disc text-body-2 text-tertiary">{t3}{t5}{t7}{t9}{t11}{t13}{t15}</ul>;
    $[31] = t11;
    $[32] = t13;
    $[33] = t15;
    $[34] = t3;
    $[35] = t5;
    $[36] = t7;
    $[37] = t9;
    $[38] = t16;
  } else {
    t16 = $[38];
  }
  let t17;
  if ($[39] !== t1 || $[40] !== t16) {
    t17 = <Section title={t1}>{t16}</Section>;
    $[39] = t1;
    $[40] = t16;
    $[41] = t17;
  } else {
    t17 = $[41];
  }
  return t17;
};
export default InvestorProfileSection;
function _temp($) {
  return $.title;
}
function _temp2($_0) {
  return $_0.employment;
}
function _temp3($_1) {
  return $_1.income;
}
function _temp4($_2) {
  return $_2.netWorth;
}
function _temp5($_3) {
  return $_3.funding;
}
function _temp6($_4) {
  return $_4.goals;
}
function _temp7($_5) {
  return $_5.risk;
}
function _temp8($_6) {
  return $_6.family;
}